let { jQuery: $ } = window;
import Utils from "./utils.class";
import CMP from "./CMP.class";

export default class Cookiebot extends CMP {
    constructor($body,debug = false) {
        let readyFlag = false;
        super($body, () => readyFlag || (window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent["necessary"]), debug);

        window.addEventListener("CookiebotOnConsentReady", () => readyFlag = true);
        window.addEventListener("CookiebotOnAccept", () => this.#changeConsent());
        window.addEventListener("CookiebotOnDecline", () => this.#changeConsent());
    }

    load() {
        Utils.log("Loading Cookiebot Integration.");

        for(let i in this.types) {
            const type = this.types[i];

            if(this.hasConsent(type)) {
                $(window).trigger(this.events.consent[type]);
            } else {
                $(window).trigger(this.events.denied[type]);
            }
        }
    }

    hasConsent(category) {
        if(!this.isDebug) {
            return window.Cookiebot.consent[category];
        }

        return true;
    }

    setConsent(category, value) {
        let state = {
            "preferences": this.hasConsent("preferences"),
            "statistics": this.hasConsent("statistics"),
            "marketing": this.hasConsent("marketing")
        };

        if(typeof category === 'string') {
            state[category] = value;
        } else {
            for(let i in category) {
                state[category[i]] = value;
            }
        }

        window.Cookiebot.submitCustomConsent(state.preferences, state.statistics, state.marketing)
    }

    open() {
        window.Cookiebot.show();
    }

    #changeConsent() {
        for(let i in this.types) {
            const type = this.types[i];

            if(this.hasConsent(type)) {
                $(window).trigger(this.events.consent[type]);
            } else {
                $(window).trigger(this.events.denied[type]);
            }
        }
    }


    get consentTypes() {
        return ["necessary", "preferences", "marketing", "statistics"];
    }
}